import { type StringOption } from '@models/Option';

interface QueryResultType {
    edges: {
        node: {
            id: string;
            name: string;
        };
    }[];
}

export function mapQueryResultToOptions<T extends QueryResultType>(
    results?: T,
): StringOption[] {
    if (!results) {
        return [];
    }
    return results.edges
        .map((e) => e.node)
        .map((node) => ({
            value: node.id,
            label: node.name,
        }));
}
